import React, { useState, useCallback } from 'react';
import { Dimensions, Pressable, StyleSheet, } from 'react-native';
import { View } from '../elements';
import { Image } from '../shared';
import { useWindowHeight } from '../..';
import { Info } from './buttons';
export const PlayerImage = ({ track, description = '', }) => {
    const heightD2 = useWindowHeight() / 3;
    const [width, setWidth] = useState(Dimensions.get('window').width);
    const onLayout = useCallback(({ nativeEvent: { layout: { width } } }) => {
        setWidth(width);
    }, []);
    const [isOpen, setIsOpen] = useState(false);
    return (React.createElement(View, { style: styles.container, onLayout: onLayout },
        React.createElement(Pressable, { style: styles.imageContainer, onPress: () => setIsOpen(true) },
            React.createElement(Image, { uri: track.artwork, defaultDimensions: { height: Math.min(heightD2, width), width }, heightConstraint: Math.min(heightD2, width), widthConstraint: width })),
        isOpen ? React.createElement(Info, { onClose: () => setIsOpen(false), title: track?.title, description: description }) : null));
};
const styles = StyleSheet.create({
    container: {
        alignItems: 'center',
        justifyContent: 'center',
        maxWidth: '100%',
        maxHeight: '100%',
        overflow: 'hidden',
    },
    imageContainer: {
        borderRadius: 10,
        overflow: 'hidden',
        marginBottom: 20,
    },
    buttonContainer: {
        right: 10,
        bottom: 10,
        position: 'absolute',
        backgroundColor: 'transparent',
    },
});
//# sourceMappingURL=PlayerImage.js.map